<template>
  <div :class="status ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-small" v-if="!checkoutDisabled">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p
          class="modal-card-title has-text-black"
        >{{ confirmStep < 3 ? 'Confirm Order' : 'Thank you for your order' }}</p>
      </header>

      <section class="modal-card-body has-text-centered ph15" v-show="confirmStep == 1">
        <template>
          <img src="@/assets/img/icon-basket.svg" alt="Basket" class="mt20 mb20" />
          <p class="sub-title is-size-14 has-text-black">
            Are you sure you want to checkout?
            <br />
          </p>
          <div class="guest-user-chekout-fields"><!-- v-if="!$store.getters.getLoggedInUserToken" we made this available for all -->
            <h5 class="text-left mb-5 has-text-black">Your details</h5>
            <div class="field">
              <div class="control">
                <validation-provider name="first name" ref="first_name" rules="required|min:2">
                  <template #default="{ errors }">
                    <input
                      v-model="user.first_name"
                      autocomplete="new-password"
                      class="input checkout-user-field"
                      name="first_name"
                      type="text"
                      placeholder="First Name"
                    />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </template>
                </validation-provider>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <validation-provider name="last name" ref="last_name" rules="required|min:2">
                  <template #default="{ errors }">
                    <input
                      v-model="user.last_name"
                      autocomplete="new-password"
                      class="input checkout-user-field"
                      name="last_name"
                      type="text"
                      placeholder="Last Name"
                    />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </template>
                </validation-provider>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <validation-provider name="email" ref="email" rules="required|email">
                  <template #default="{ errors }">
                    <input
                      v-model="user.email"
                      autocomplete="new-password"
                     :class="'input checkout-user-field'+ ($store.getters.getLoggedInUserToken ? ' field-disabled' : '')"
                      name="email"
                      type="text"
                      placeholder="Email"
                      rules="required|email"
                    />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </template>
                </validation-provider>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <validation-provider name="phone" ref="phone" rules="required|phone_number|numeric">
                  <template #default="{ errors }">
                    <input
                      v-model="user.phone"
                      :class="'input checkout-user-field hide-arrow'+ ($store.getters.getLoggedInUserToken ? ' field-disabled' : '')"
                      name="phone"
                      rules="required|phone_number|numeric"
                      type="number"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      placeholder="Phone"
                    />
                    <span class="validation-error">{{ errors[0] }}</span>
                  </template>
                </validation-provider>
              </div>
            </div>

            <div class="field has-text-left has-text-black">
              <input
                class="is-checkradio"
                v-model="user.sms_notification"
                id="sms_notification"
                type="checkbox"
                value="1"
              />
              <label for="sms_notification">SMS notification</label>
            </div>

            <div class="field has-text-left has-text-black">
              <input
                class="is-checkradio"
                v-model="user.email_notification"
                id="email_notification"
                type="checkbox"
                value="1"
              />
              <label for="email_notification">Email notification</label>
            </div>
          </div>

          <div class="monaris-iframe-wrapper">
            <div class="level is-mobile px-2 mb-5">
              <div class="field mt-5 relative-top-4 has-text-black" v-if="enablePayNow">
                <input
                  class="is-checkradio"
                  v-model="pay_later"
                  id="paynowCheck"
                  type="radio"
                  :value="0"
                />
                <label for="paynowCheck" class="text-dark">Pay now</label>
              </div>

              <div class="field mt-5 has-text-black" v-if="enablePaylater">
                <input
                  class="is-checkradio"
                  v-model="pay_later"
                  id="paynowCheck2"
                  type="radio"
                  :value="1"
                />
                <label for="paynowCheck2" class="text-dark">Pay at store</label>
              </div>
            </div>


            <!-- monaris card info -->
            <template  v-if="vg_selectedLocation.settings.payment_processor_details.provider_name == 'moneris_payment' && enablePayNow">
              <!-- template check value par later value hide n show -->
              <h3 v-show="pay_later == 0" class="billing-heading heading-with-lock"><strong>Credit card</strong> <i class="fas fa-lock"></i></h3>
              <iframe
                v-show="pay_later == 0"
                id="monerisFrame"
                :src="monerisIframeUrl"
                frameborder="0"
                width="100%"
              ></iframe>
            </template>
           
            <!-- elavon info -->
            
            <div class="elavon-payment-detail-wrap " v-if="(pay_later == 0) && (vg_selectedLocation.settings.payment_processor_details.provider_name == 'elavon_payment') && enablePayNow">
              <h3 class="billing-heading heading-with-lock"><strong>Credit card</strong>  <i class="fas fa-lock"></i></h3>
              <div class="field">
                <div class="control">
                  <validation-provider name="card number" ref="elavon_card_number" rules="required">
                    <template #default="{ errors }">
                      <input
                        v-model="elavon.card_number"
                        class="input checkout-user-field hide-arrow"
                        name="Card Number"
                        onKeyPress="if(this.value.length==16) return false;"
                        type="number"
                        placeholder="Card Number"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
              <div class="field">
                <div class="control">

                  <validation-provider name="card expiry date" ref="elavon_exp_date" rules="required">
                    <template #default="{ errors }">
                      <input
                        v-model="elavon.exp_date"
                        class="input checkout-user-field"
                        name="Card Expiry date"
                        onKeyPress="if(this.value.length==4) return false;"
                        type="text"
                        placeholder="MMYY"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <validation-provider name="CVV2" ref="elavon_cvv2cvc2" rules="required">
                    <template #default="{ errors }">
                      <input
                        v-model="elavon.cvv2cvc2"
                        onKeyPress="if(this.value.length==4) return false;"
                        class="input checkout-user-field"
                        name="CVV2"
                        type="number"
                        placeholder="CVV2"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
              
              <h3 class="billing-heading">Billing Details</h3>
              <div class="field">
                <div class="control">
                  <validation-provider name="billing address" ref="elavon_billing_address" rules="required">
                    <template #default="{ errors }">
                      <input
                        v-model="elavon.address"
                        class="input checkout-user-field"
                        name="billing address"
                        type="text"
                        placeholder="Billing address"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <validation-provider name="billing zip" ref="elavon_billing_zip" rules="required">
                    <template #default="{ errors }">
                      <input
                        v-model="elavon.zip"
                        class="input checkout-user-field"
                        name="billing zip"
                        type="text"
                        placeholder="Billing zip"
                      />
                      <span class="validation-error">{{ errors[0] }}</span>
                    </template>
                  </validation-provider>
                </div>
              </div>

            </div>


            <!-- paysafe card info -->
            <div
              class="paysafe-wrapper"
              v-if="vg_selectedLocation.settings.payment_processor_details.provider_name == 'merrco_payment'"
            >
              <div v-show="pay_later == 0 && enablePayNow">
                <!-- hide and show, so no need to refetch data -->
                <h3 class="billing-heading heading-with-lock"><strong>Credit card</strong>  <i class="fas fa-lock"></i></h3>
                
                <div id="cardNumber" class="paysafe-inputs"></div>
                <div id="expiryDate" class="paysafe-inputs"></div>
                <div id="cvv" class="paysafe-inputs"></div>

                <!-- if payment type is paysafe we need to capture billing details -->
                <h3 class="billing-heading">Billing Details</h3>
                <div class="field">
                  <div class="control">
                    <validation-provider name="Street" ref="billing_street" rules="required">
                      <template #default="{ errors }">
                        <gmap-autocomplete
                          autocomplete="nope"
                          id="billing_address"
                          class="input has-bg-grey google-autocomplete has-text-black"
                          style="height: 2.625rem; padding: 10px 20px 10px 20px; color: #666666; font-size: 0.9375rem; background-color: #fff; box-shadow: none; border-radius: 4px; border: none; width: 100%;border: 1px solid #808080;"
                          large
                          name="billing_street"
                          placeholder="Street"
                          @place_changed="setBillingStreet"
                          @keyup="resetBillingStreet"
                          :select-first-on-enter="true"
                        ></gmap-autocomplete>
                        <span
                          class="validation-error"
                          v-if="billingStreetError"
                        >{{ billingStreetError }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <validation-provider name="City" ref="billing_city" rules="required">
                      <template #default="{ errors }">
                        <input
                          v-model="billingDetails.city"
                          class="input"
                          name="City"
                          type="text"
                          placeholder="City"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <validation-provider name="State" ref="billing_state" rules="required">
                      <template #default="{ errors }">
                        <input
                          v-model="billingDetails.state"
                          class="input"
                          name="State"
                          type="text"
                          placeholder="State"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <validation-provider name="Country" ref="billing_country" rules="required">
                      <template #default="{ errors }">
                        <input
                          v-model="billingDetails.country"
                          class="input"
                          name="Country"
                          type="text"
                          placeholder="Country"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <validation-provider name="Zip" ref="billing_zip" rules="required">
                      <template #default="{ errors }">
                        <input
                          v-model="billingDetails.zip"
                          class="input"
                          name="Zip"
                          type="text"
                          placeholder="Zip"
                        />
                        <span class="validation-error">{{ errors[0] }}</span>
                      </template>
                    </validation-provider>
                  </div>
                </div>
                <!-- paysafe billing details ends -->
              </div>
            </div>

            <div class="checkout-offers mt20" v-show="vg_user.marketing_notification == false">
              <div class="field has-text-left has-text-black">
                <div @click.prevent="setMarketingNotification()">
                  <input
                    class="is-checkradio"
                    v-model="user.marketing_notification"
                    id="user_marketing_notification"
                    type="checkbox"
                    value="1"
                  />
                  <label class="offer-notification-label" for="user_marketing_notification">
                    Sign up for new offers and discounts
                  </label>
                </div>
                <p><em>By selecting Opt-in, you agree to the <router-link :to="{ name: 'TermsConditions'}">Terms of Use</router-link> and <router-link :to="{ name: 'PrivacyPolicy'}">Privacy Policy</router-link></em></p>
              </div>
            </div>
          </div>
        </template>
      </section>

      <section class="modal-card-body ph20 has-text-centered" v-show="confirmStep == 2">
        <div class="spin-loader mb100 mt100"></div>
      </section>

      <section class="modal-card-body has-text-centered ph15" v-show="confirmStep == 3">
        <img src="@/assets/img/icon-card.svg" alt="card" class="mt20 mb20" />
        <p
          class="modal-card-title is-size-14 mb10 has-text-black"
        >Please check your email for order confirmation. Don't forget payment and ID at pickup.</p>
        <p
          class="sub-title is-size-14 has-text-black"
        >Your government-issued ID must match account name and birthday.</p>
      </section>

      <footer
        class="modal-card-foot"
        v-if="checkoutDisabled == false"
        v-show="confirmStep == 1 || confirmStep == 3"
      >
        <!-- next prev button -->
        <div class="next-prev-button" v-show="confirmStep == 1">
          <!-- if pay now -->
          <div v-show="pay_later == 0">
            <!-- <button
              v-if="guestOnly"
              class="button is-large is-primary is-full-width"
              @click="processCart()"
            >Yes, Confirm Order</button>-->

            <button
              class="button is-large is-primary is-full-width"
              v-show="vg_selectedLocation.settings.payment_processor_details.provider_name == 'moneris_payment' || vg_selectedLocation.settings.payment_processor_details.provider_name == ''"
              @click="processCart()"
            >Yes, Confirm Order</button>

            <button
              v-show="vg_selectedLocation.settings.payment_processor_details.provider_name == 'elavon_payment'"
              @click="processCart()"
              class="button is-large is-primary is-full-width"
            >Yes, Confirm Order</button>

            <button
              v-show="vg_selectedLocation.settings.payment_processor_details.provider_name == 'merrco_payment'"
              id="paySafe"
              class="button is-large is-primary is-full-width"
            >Yes, Confirm Order</button>
          </div>

          <!-- pay later / pay at store -->
          <div v-show="pay_later == 1">
            <button
              class="button is-large is-primary is-full-width"
              @click="processCart()"
            >Yes, Confirm Order</button>
          </div>
          <button @click="closeModal()" class="button is-large is-white is-full-width">Cancel</button>
        </div>

        <!-- Successful checkout -->
        <div class="next-prev-button" v-show="confirmStep == 3">
          <button
            class="button mb-3 is-large is-primary is-full-width"
            v-if="$store.getters.getLoggedInUserToken"
            @click.prevent="showOrderStatus()"
          >View Order Status</button>
          <button
            class="button is-large button-accent has-text-white is-full-width"
            @click.prevent="continueShopping()"
          >Continue Shopping</button>
        </div>
      </footer>
    </div>
    <div class="modal-card is-small" v-else>
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title has-text-black">Sorry</p>
      </header>
      <section class="modal-card-body has-text-centered ph15">
        <p>We aren't able process payments right now. Please try again later.</p>
      </section>
      <footer class="modal-card-foot">
        <!-- next prev button -->
        <div class="next-prev-button">
          <button class="button is-large is-primary is-full-width" @click="closeModal()">Go Back</button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import Env from '@/env';
import { mapGetters, mapActions, mapMutations } from "vuex";
import CheckoutApis from '@/Components/Controllers/CheckoutApis';
import moment from 'moment';
import 'moment-timezone';
moment.tz.setDefault('America/Toronto');
import { debounce } from 'lodash';
import Helpers from '@/Components/Helpers/Helpers';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import UserApis from '@/Components/Controllers/UserApis';
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';

export default {
  name: 'CartConfirmOrderModal',
  data() {
    return {
      interval_14_minute: null,
      modal: false,
      confirmStep: 1,
      orderConfirmDetail: {},
      receive_time: '',
      order_receive_method: '',
      monerisEventLoaded: false,
      pay_later: 1,
      delivery: {
        address1: '',
        addreess2: '',
        province: '',
        city: '',
        postal_code: '',
        note: '',
        phone: '',
        latitude: '',
        longitude: '',
      },

      delivery_fee: 0,
      user: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        sms_notification: false,
        email_notification: false,
        marketing_notification: false
      },
      billingStreetError: '',
      billingDetails: {
        street: '',
        city: '',
        state: '',
        country: '',
        zip: ''
      },
      grandTotal: 0,

      elavon:{
        session_token: '',
        card_number: '',
        exp_date: '',
        cvv2cvc2: '',
        address: '',
        zip: '',
      },
    };
  },
  props:{
    status: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      vg_selectedLocation: "location/selected",
      vg_cartId: "cart/id",
      vg_cartItems: "cart/cartItems",
      vg_cartTax: "cart/cartTax",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_user: "getLoggedInUser",
    }),
    /**
     * Guest user / guest_only active
     */
    guestOnly() {
      if (this.vg_guestLandedQueries['guest-only'] || this.vg_guestLandedQueries['guest-only'] == 'true' || this.$route.query['guest-only']) {
        return this.vg_selectedLocation.settings.kiosk_settings?this.vg_selectedLocation.settings.kiosk_settings.is_enabled: false
      }
      return false;
    },
    /**
     * checkout disabled mean store doesnot have pay now or later option so hide all buttons
     */
    checkoutDisabled() {
      if (this.enablePayNow == false && this.enablePaylater == false) {
        return true;
      }
      return false;
    },

    /**
     * Paynow enable / disable
     */
    enablePayNow() { 
      // Disable pay now if location has blank moneris data 
      if( this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'moneris_payment'){
        if( this.vg_selectedLocation.settings.payment_processor_details.payment_info == '' ){
          return false;
        }
      }
      // For guest
      if (this.guestOnly) {
        // overide if guest only
        return this.vg_selectedLocation.settings.kiosk_settings.pay_now;
      }
      if (this.order_receive_method == 'pickup') {
        return this.vg_selectedLocation.settings.pickup_orders? this.vg_selectedLocation.settings.pickup_orders.pay_now:true
      } else if (this.order_receive_method == 'delivery') {
        return this.vg_selectedLocation.settings.delivery_orders? this.vg_selectedLocation.settings.delivery_orders.pay_now : true
      }
      return true;
    },

    /**
     * Paylater enable / disable
     */
    enablePaylater() {

      if (this.guestOnly) {
        // overide if guest only
        return this.vg_selectedLocation.settings.kiosk_settings.pay_later;
      }

      if (this.order_receive_method == 'pickup') {
        return this.vg_selectedLocation.settings.pickup_orders && this.vg_selectedLocation.settings.pickup_orders.pay_later
      } else if (this.order_receive_method == 'delivery') {
        return this.vg_selectedLocation.settings.delivery_orders && this.vg_selectedLocation.settings.delivery_orders.pay_later
      }
      // depending on selected field pay later
      return true;
    },

    monerisIframeUrl() {
      return `${Env.moneris.url}?id=${this.vg_selectedLocation.settings.payment_processor_details.payment_info ?  this.vg_selectedLocation.settings.payment_processor_details.payment_info : Env.moneris.id}&pmmsg=true&enable_exp=1&enable_cvd=1&css_body=background:white;&css_textbox=width:100%;background:white;padding:10px;border-radius:5px;border:1px%20solid%20grey;height:40px;border-color:grey;font-size:16px;margin-top:8px;&display_labels=2&exp_label=Expiry Date (MMYY)`;
    },
  },

  watch: {
  
    'user.phone'(val){
      if(val.indexOf(".") != -1) {
        this.user.phone = val.replace(/\./g,"");
      }
      let newval = val.trim();
      if(val.length > 10){
        newval = newval.slice(0,10)
      } 
      this.user.phone = newval;
    },

    pay_later: {
       handler: async function(x) {
        if (x === 0) {
          // if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'merrco_payment') {
          //   await this.$nextTick()
          //   this.loadPaysafeJs(Env.paysafe.url)
          // }

          // watch pay later if pay now is true with moneris listen to event 
          // if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'moneris_payment' && this.monerisEventLoaded == false) {

          //   if (window.addEventListener) {
          //     window.addEventListener("message", this.monerisResponse, false);
          //   } else {
          //     if (window.attachEvent) {
          //       window.attachEvent("onmessage", this.monerisResponse);
          //     }
          //   }
          //   // once event loaded make it true / loaded, load only once
          //   this.monerisEventLoaded = true;
          // }

        }
      },
      immediate: true
    }
  },

  destroyed() {
    // destroy interval
    if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'elavon_payment') {
      clearInterval(this.interval_14_minute);
    }
  },

  async mounted() {

    // If user is logged in auto fill user details
    if(this.$store.getters.getLoggedInUserToken){
      let user = this.$store.getters.getLoggedInUser;
      this.user = {
        first_name: user.first_name, 
        last_name: user.last_name,
        phone: user.phone,
        email: user.email,
        sms_notification: user.sms_notification ? true : false,
        email_notification: user.email_notification,
        marketing_notification: user.marketing_notification,
      };
     
    }

    // G tracking begin checkout
    this.$gtag.event('begin_checkout', { 
      items: Helpers.GTagKeyValueForChekout(this.vg_cartItems),
    });

    bus.$on('show-modal-confirm-order', (payload) => {
      this.receive_time = payload.pickupTime;
      this.order_receive_method = payload.order_receive_method;
      this.delivery = payload.delivery;
      this.delivery_fee = payload.delivery_fee;
      this.grandTotal = payload.grandTotal;
    })

    // Load paysafe if payment is paysafe
    if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'merrco_payment') {
      this.loadPaysafeJs(Env.paysafe.url)
      // on next tick add attribute on autocomplete, not workiong so lets set time out for 1 sec to add
      setTimeout(function(){
        // once the div loaded change it 
        document.getElementById("billing_address").setAttribute("autocomplete", "nope");
      }, 1000)
    }

    // Load elavon iframes

    if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'elavon_payment') {
      this.loadElavonJs(Env.elavon.jsurl)
    }

    // Setup for monaris
    if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'moneris_payment' && this.monerisEventLoaded == false) {
      if (window.addEventListener) {
        window.addEventListener("message", this.monerisResponse, false);
      } else {
        if (window.attachEvent) {
          window.attachEvent("onmessage", this.monerisResponse);
        }
      }
      // once event loaded make it true / loaded, load only once
      this.monerisEventLoaded = true;
    }

    // if guest user we are now going to overide the pay later / now via  kiosk_settings
    // if (this.guestOnly) {
    //   this.pay_later = 0;
    // }
    //this.pay_later = 0;
    await this.$nextTick()
    if (this.enablePayNow) {
      this.pay_later = 0;
    } if(this.enablePaylater) {
      this.pay_later = 1
    }
  },

  beforeDestroy() {
    bus.$off('show-modal-confirm-order');
  },

  methods: {
    setMarketingNotification() {
      this.user.marketing_notification = !this.user.marketing_notification;
    },
    /**
     * Set billing street
     */
    async setBillingStreet(billingAddress) {
      if (_.isEmpty(billingAddress)) {
        return;
      }
      if(billingAddress.name){
        // instead of long text display onnly the street name
        document.getElementById('billing_address').value = billingAddress.name;
      }

      this.billingStreetError = '';
      let postcode = this.getDetailFromGmapAutoComplete(billingAddress.address_components, 'postal_code');
      if (postcode == '') {
        // reset billing values
        this.billingDetails = Helpers.setObjValueEmpty(this.billingDetails);
        return this.va_snackbar({
          type: "warning",
          message: "Cannot find your post code. Please type in full Address."
        });
      }
      this.billingDetails = {
        street: billingAddress.name,
        city: this.getDetailFromGmapAutoComplete(billingAddress.address_components, 'locality'),
        state: this.getDetailFromGmapAutoComplete(billingAddress.address_components, 'administrative_area_level_1', 'short_name') ? this.getDetailFromGmapAutoComplete(billingAddress.address_components, 'administrative_area_level_1', 'short_name') : this.getDetailFromGmapAutoComplete(billingAddress.address_components, 'administrative_area_level_2', 'short_name'),
        country: this.getDetailFromGmapAutoComplete(billingAddress.address_components, 'country', 'short_name'),
        zip: postcode,
      };
    },

    resetBillingStreet($e) {
      let billingAddress = $e.target.value
      if (billingAddress == undefined || billingAddress == '') {
        // now reset 
        this.billingDetails = {
          street: '',
          city: '',
          state: '',
          country: '',
          zip: ''
        };
        return this.billingStreetError = "Invalid address.";
      } else {
        this.billingStreetError = "";
      }
    },

    /**
     * get the value from gmap auto component
     */
    getDetailFromGmapAutoComplete(address_components, $key, type = 'long_name') {
      let returnValue = '';
      let searchdata = address_components.find(item => {
        if (_.indexOf(item.types, $key) > -1) {
          return item;
        }
      })
      if (searchdata != undefined) {
        returnValue = searchdata[type]
      }
      return returnValue;
    },

    monerisResponse: function (e) {
      if (this.vg_selectedLocation.settings.payment_processor_details.provider_name != 'moneris_payment') {
        return;
      }

      if (e.data && e.data != undefined) {
        if (typeof e.data == 'object') {
          // only string is allowed
          return;
        }
      }
    
      var respData = eval("(" + e.data + ")");
      if (respData.dataKey) {
        this.confirmOrder({ token: respData.dataKey });
      } else {
        this.va_snackbar({
          type: "warning",
          message: respData.errorMessage,
        });
      }
    },

    /**
     * Load elavon js 
     */
    loadElavonJs(jsUrl) {
      const self = this;
      // remove existing if any to prevent double 
      var elavonLib = document.getElementById("elavon_js");
      if (elavonLib) {
        elavonLib.parentNode.removeChild(elavonLib)
      }
      // get all js and check if we have already loaded this js
      var allScript = document.scripts;
      for (var i = 0, max = allScript.length; i < max; i++) {
        if (allScript[i].src == jsUrl)
          return;
      }

      new Promise(function (resolve, reject) {
        let sc = document.createElement('script');
        sc.setAttribute('id', 'elavon_js');
        sc.src = jsUrl;
        document.head.appendChild(sc);
        sc.onload = function () {
           console.log('elevon loaded') 
          // Trigger ends 
          resolve();
        };
      });
    },

    /**
     * load paysafe js 
     */
    loadPaysafeJs(jsUrl) {
      const self = this;
      // remove existing if any to prevent double 
      var paysafeLib = document.getElementById("paysafe_js");
      if (paysafeLib) {
        paysafeLib.parentNode.removeChild(paysafeLib)
      }
      // get all js and check if we have already loaded this js
      var allScript = document.scripts;
      for (var i = 0, max = allScript.length; i < max; i++) {
        if (allScript[i].src == jsUrl)
          return;
      }

      new Promise(function (resolve, reject) {
        let sc = document.createElement('script');
        sc.setAttribute('id', 'paysafe_js');
        sc.src = jsUrl;
        document.head.appendChild(sc);
        sc.onload = function () {
          console.log('loaded paysafe')
          paysafe.fields.setup(self.vg_selectedLocation.settings.payment_processor_details.token_key, Env.paysafe.options, function (instance, error) {
            
            let paysafeButton = document.getElementById("paySafe");
            if(paysafeButton){
              paysafeButton.addEventListener("click", async () => {
                let validation;
                if (self.pay_later == 1) {
                  console.log('escaping paysafe trigger')
                  return
                }
        
                if (!self.$store.getters.getLoggedInUserToken) {
                  if (self.guestOnly) {
                    validation = await Helpers.validateRefs(self, ['first_name', 'billing_city', 'billing_state', 'billing_country', 'billing_zip']);
                  } else {
                    validation = await Helpers.validateRefs(self, ['first_name', 'last_name', 'phone', 'email', 'billing_city', 'billing_state', 'billing_country', 'billing_zip']);
                  }
                  // Autocomplete field is empty then
                  if (self.billingDetails.street == '') {
                    self.billingStreetError = "Invalid Address.";
                    return;
                  }
                  if (!validation) {
                    // reject is guest user detail failed
                    return false;
                  }
                } else {
                  // if user logged in then validate 
                  // Autocomplete field is empty then
                  if (self.billingDetails.street == '') {
                    self.billingStreetError = "Invalid Address.";
                    return;
                  }
                  validation = await Helpers.validateRefs(self, ['billing_city', 'billing_state', 'billing_country', 'billing_zip']);
                  if (!validation) {
                    // reject is guest user detail failed
                    return false;
                  }
                }

                // Validate product and variant when paysafe payment is active
                let unavailableVariants = self.checkUnavailaleItemsOfCartitems();
                if(unavailableVariants.modal){
                  // there are some unavailable variants/ products please stop with alert
                  return bus.$emit('item-no-longer-onstock', {
                    modal: true,
                    message: unavailableVariants.message,
                  });
                }

                self.confirmStep = 2;
                // new tokenise
                instance.tokenize({
                  vault: {
                    holderName: self.user.first_name + ' ' + self.user.last_name,
                  }
                }, function(instance, error, result) {
                  if (error) {
                    self.confirmStep = 1;
                    self.va_snackbar({
                      type: "warning",
                      message: error.displayMessage
                    });
                  } else {
                    // merrco_payment start
                    self.confirmOrder({ token: result.token })
                  }
                });
              }, false);
            }
          });
          // Trigger ends 
          resolve();
        };
      });
    },
    
    /**
     * Close modal
     */
    closeModal() {
      this.modal = false;
      this.confirmStep = 1;
      this.orderConfirmDetail = {};
      this.$emit('close-modal')
    },

    /**
     * get moneris data
     */
    getMonerisData() {
      var monFrameRef = document.getElementById('monerisFrame').contentWindow;
      monFrameRef.postMessage('tokenize', `${Env.moneris.url}?id=${this.vg_selectedLocation.settings.payment_processor_details.token_key}`);
    },

    /**
     * Check availablility of product on stock
     */
    async checkUnavailaleItemsOfCartitems() {
      // Collect Location variant ids to pass on api to check its latest availability
      let cartItemVariantIds = _.map(this.vg_cartItems, 'location_product_variant_id');
      let checkVariantsAvailability = await ProductApis.getProductVaraintByIds(cartItemVariantIds);
      if(checkVariantsAvailability.status != 200){
        console.log('failed to check availability of variants.')
        return {
          modal: false,
          message: null,
        };  
      }
      // On success, filter and collect variants whose inventory is less than out of stock or availability false 
      let unavailableVariants = _.filter(checkVariantsAvailability.data.payload, function(o) { 
                                  return o.no_of_units <= o.inventory_threshold || o.available == false
                                }); 
      // If there is any variants which match the reject logic
      if(unavailableVariants.length > 0){
        this.closeModal();
        // Create message
       let message = 'Unfortunately the following <br/>';
        message +=  unavailableVariants.length > 1 ? 'products are no longer in stock.<br/>' : 'product is no longer in stock.<br/>';
        // foreach all variant who pass the reject logic
        unavailableVariants.forEach( async(item) => {
          let hasUnavailableVariant = _.find(this.vg_cartItems, { location_product_variant_id: item.id });
          // match the variant id on cart item to delete
          if(hasUnavailableVariant != undefined){
            // store product name size
            message += '<br/> ' + item.name + ' Size: ' + item.size;
            // delete item from cart
            let res = await CartApis.delete({
              cart_product_id: hasUnavailableVariant.id, // mean the cart service product id which is aaded per variant
              location_id: this.$store.getters['location/selected'].id ? this.$store.getters['location/selected'].id : '',
            });
          }
        })
        return {
          modal: true,
          message: message,
        }; 
      } 

      return {
        modal: false,
        message: null,
      }; 

    },
   
    /**
     * Process cart
     * this function is triggered for monaris and all pay later
     */
    async processCart() {
      // first of of if user is not login validate user details
      // if (!this.$store.getters.getLoggedInUserToken) {
      //   let validation;
      //   if (this.guestOnly) {
      //     validation = await Helpers.validateRefs(this, ['first_name']);
      //   } else {
      //     validation = await Helpers.validateRefs(this, ['first_name', 'last_name', 'phone', 'email']);
      //   }
      //   if (!validation) {
      //     return false;
      //   }
      // }

      // Validate for all logged and guest, guest can have only fname but rest must have all details filled in 
      let validation;
      if (this.guestOnly) {
        validation = await Helpers.validateRefs(this, ['first_name']);
      } else {
        validation = await Helpers.validateRefs(this, ['first_name', 'last_name', 'phone', 'email']);
      }

       if( (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'elavon_payment') && (this.pay_later == 0 ) ){
        // Validate card fields before submit for elavon and
        let validateElavonCard = await Helpers.validateRefs(this, ['elavon_card_number', 'elavon_exp_date', 'elavon_cvv2cvc2', 'elavon_billing_address', 'elavon_billing_zip']);
        if (!validateElavonCard) {
          return false;
        }
      }

      if (!validation ) {
        return false;
      }

      let unavailableVariants = this.checkUnavailaleItemsOfCartitems();
      if(unavailableVariants.modal){
        // there are some unavailable variants/ products please stop with alert
        return bus.$emit('item-no-longer-onstock', {
          modal: true,
          message: unavailableVariants.message,
        });
      }

      if (this.pay_later === 1) {
        // we dont need to add moneris in between
        // lets confirm order 
        this.confirmOrder({ token: null })
      } else {
        // If pay now we have 3 options monaris, paysafe, elavon
        if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'moneris_payment') {
           // we have to get data from moneris
          this.getMonerisData();
        } else if(this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'elavon_payment'){
          this.generateElavonTokenAndConfirm();
         } else {
           console.log('payment method not found')
         }
      }
    },

    /**
     *  generate session token
     */
    async generateElavonSessionToken() {
      let elavonSessionToken = await CartApis.generateElavonSessionToken(this.vg_selectedLocation.id);
      if(elavonSessionToken.status == 200){
        this.elavon.session_token = elavonSessionToken.data.payload.session_token;
      } else {
        this.elavon.session_token = '';
      }
    },

     /**
     * Generate elavon token and Confirm
     */
    async generateElavonTokenAndConfirm() { 
      
      const self = this;
      self.confirmStep = 2;
      // This will attach session token on elavon
      await this.generateElavonSessionToken();
      ConvergeEmbeddedPayment.pay({
        ssl_txn_auth_token: this.elavon.session_token,
        ssl_card_number: this.elavon.card_number,
        ssl_exp_date: this.elavon.exp_date,
        ssl_verify: 'Y',
        ssl_avs_address: this.elavon.address,
        ssl_avs_zip: this.elavon.zip,
        ssl_get_token: 'Y',
        ssl_add_token: 'Y',
        ssl_first_name: this.user.first_name,
        ssl_last_name: this.user.last_name,
        ssl_cvv2cvc2: this.elavon.cvv2cvc2,
        ssl_amount: 0.00,
        ssl_merchant_txn_id: this.vg_cartId,// need to send cart id this.vg_selectedLocation.settings.payment_processor_details.ssl_merchant_id ? this.vg_selectedLocation.settings.payment_processor_details.ssl_merchant_id : Env.elavon.ssl_merchant_id
      }, {
        onError: function (error) {
          console.log('error')            
          self.confirmStep = 1;
          self.va_snackbar({
            type: "warning",
            message: error.errorMessage
          });
        },
        onDeclined: function (response) {
          console.log('decline')
          self.confirmStep = 1;
          self.va_snackbar({
            type: "warning",
            message: response.errorMessage ? response.errorMessage : 'Card ' + response.ssl_token_response,
          });
        },
        onApproval: function (response) {
          console.log(response)
          self.confirmOrder({ token: response.ssl_token });
        }
      });
    
    },

    /**
     * Confirm order
     */
    confirmOrder: _.debounce(async function ({ token }) {
    
      // Checkout failed id payment is elavon regenerate session token
      if (this.pay_later == 0) {
        if (token == '') {
          // reject if no  token
          this.confirmStep = 1;
          this.va_snackbar({
            code: "warning",
            message: "Cannot find payment token."
          });
          return;
        }
      }
      this.confirmStep = 2;
      moment.tz.setDefault(this.vg_selectedLocation.address.timezone_id ? this.vg_selectedLocation.address.timezone_id : 'America/Toronto');
      let a = moment(this.receive_time, "YYYY-MM-DD hh:mm a").tz(this.vg_selectedLocation.address.timezone_id ? this.vg_selectedLocation.address.timezone_id : 'America/Toronto');
      let utcTime = a.utc().format('YYYY-MM-DD HH:mm:ss');
      let obj = {
        cartId: this.vg_cartId,
        // business_slug: this.$route.params.business_slug,
        receive_time: utcTime,
        pay_later: this.pay_later == 1 ? true : false,
        token: token,
        order_receive_method: this.order_receive_method,
        delivery: this.delivery,
        delivery_fee: this.delivery_fee,
      };
      if (!this.$store.getters.getLoggedInUserToken) {
        // if email is empty create guest email from first name
        if (this.user.email == '') {
          this.user.email = this.user.first_name.trim().replace(/\s/g, '') + '_' + moment().unix() + '@guest.com';
        }
        if (this.user.phone == '') {
          this.user.phone = '0000000000';
        }
        if (this.user.last_name == '') {
          this.user.last_name = 'guest';
        } 
      }

      // Attach user for logged in and guest
      obj.user = this.user;

      // If payment option is payasfe  then add in billing details
      if (this.vg_selectedLocation.settings.payment_processor_details.provider_name == 'merrco_payment') {
        obj.billingDetails = this.billingDetails;
      }

      let res = await CheckoutApis.checkout(obj);
      // this.confirmStep = res.status == 200 ? 3 : 1
      if (res.status == 200) {
        // Close the cart sidebar 
        await bus.$emit('open-sidebar-cart', false); 
        await this.$nextTick()
        this.orderConfirmDetail = res.data.payload;

        // pushed to vbout 
        if(this.$store.getters.getLoggedInUserToken){
          VboutApis.createOrder(res.data.payload, this.vg_selectedLocation.id)
        }
      
         // G tracking purchased item
        this.$gtag.event('purchase', { 
          transaction_id: this.orderConfirmDetail.id,
          order_id: this.orderConfirmDetail.order_id,
          affiliation: this.orderConfirmDetail.location_id,
          value: this.grandTotal.toFixed(2), // this is from frontend not api
          currency: "CAD",
          tax: this.vg_cartTax ? this.vg_cartTax : 0,
          shipping: this.delivery_fee ? this.delivery_fee : 0,
          items: Helpers.GTagKeyValueForChekout(this.vg_cartItems),
        });
        this.receive_time = '';
        this.order_receive_method = '';
        this.delivery = Helpers.setObjValueEmpty(this.delivery);
      
        this.setCartId('');
        this.setCartItems([]);
        // now fetch order history if user is logged in
        if (this.$store.getters.getLoggedInUserToken) {
          let orderRes = await OrderHistoryApis.fetch(1); // page 1
          if (orderRes.status == 200) {
            this.setAllOrders(orderRes.data.payload);
          }
        }
      
        this.setSuccessObj(res.data.payload);
        // this.confirmStep = 3;
        // Now instead of changing modal content we are going to send to a page
        // this.confirmStep = res.status == 200 ? 3 : 1
        if(this.$store.getters.getLoggedInUserToken){
          let userDetailRes  = await UserApis.fetchUserDetail();
          if(userDetailRes.status == 200){
            // On checkout we can only update fname and lname so lets update values
          this.vm_mutateUserDetailByKeys({
            first_name: userDetailRes.data.payload.first_name,
            last_name: userDetailRes.data.payload.last_name,
            marketing_notification: userDetailRes.data.payload.marketing_notification,
          })
          }
        }

        // user field reset
        this.user = Helpers.setObjValueEmpty(this.user);
        this.user.email_notification = true;
        this.user.sms_notification = true;
        this.closeModal();
        this.$router.push({ 
          name: 'CartSuccess',
          params: {
            store_slug: this.$route.params.store_slug,
            business_slug: this.$route.params.business_slug,
          },
        })

      } else {

        this.confirmStep = 1;
        let errMessage = "Error placing order."; // We get message on different keys
        if(res.response.data && res.response.data.msg){
          errMessage = res.response.data.msg
        } 
        this.va_snackbar({
          type: "warning",
          message: errMessage,
        });

      }

    }, 100),

    showOrderStatus() {
      // tab must be upcoming 
      this.setActiveTab('coming');
      this.setCurrentOrder(this.orderConfirmDetail);
      this.$router.push({
        name: 'UserOrderStatus'
      })
    },

    continueShopping() {
      this.orderConfirmDetail = {};
      this.$router.push({
        name: 'StoreProfile',
        params: {
          store_slug: this.$route.params.store_slug,
          business_slug: this.$route.params.business_slug,
        },
        query: this.vg_guestLandedQueries,
      })
    },

    ...mapMutations({
      vm_mutateUserDetailByKeys: "MUTATE_USER_DETAILS_BY_KEYS",
    }),

    ...mapActions({
      // spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      setCurrentOrder: "orderhistory/setCurrentOrder",
      setActiveTab: "orderhistory/setActiveTab",
      setCartItems: "cart/setCartItems",
      setCartId: "cart/setId",
      setAllOrders: "orderhistory/setAllOrders",
      setSuccessObj: 'cart/setSuccessObj',
    })
  },
};
</script>